import React, { useState, useEffect } from "react";
import {
  Input,
  Button,
  Col,
  Row,
  Card,
  Form,
  Tabs,
  Segmented,
  notification,
} from "antd";
import { Auth, API } from "aws-amplify";
import OtpInput from "react-otp-input";
import Loading from "../common/Loading";
import logo from "../../assets/images/logo.png";
import bgUrl from "../../assets/images/backgroundImg.png";
import "./Login.css";

function Login() {
  const [logoInfo, setLogoInfo] = useState({});
  const [appInfo, setAppInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [enableOTP, setEnableOTP] = useState(false);
  const [enableAccessCode, setEnableAccessCode] = useState(false);
  const [accessCodes, setAccessCodes] = useState([]);
  const [enteredAccessCode, setEnteredAccessCode] = useState(null);
  const [userPhone, setUserPhone] = useState("+1");
  const [userEmail, setUserEmail] = useState("");
  const [userAuthInfo, setUserAuthInfo] = useState({});
  const [otp, setOtp] = useState("");
  const [loginType, setLoginType] = useState("phone");
  const [enableTabs, setEnableTabs] = useState(null);

  useEffect(() => {
    getMasterInfo();
  }, []);

  const getMasterInfo = async (userId) => {
    await API.get("list", `/noAuth/getMasterData`, {})
      .then((response) => {
        let appInfo = response.settings;
        if (appInfo?.signupType) {
          setEnableTabs(appInfo?.signupType);
          setLoginType(
            appInfo?.signupType === "both" ? "phone" : appInfo?.signupType
          );
        }

        if (
          response.orgLogo !== undefined &&
          response.orgLogo !== null &&
          response.orgLogo !== ""
        ) {
          let logoInfo = {
            appBackgroundImage: response?.appBackgroundImage || "",
            appLogo: response?.orgLogo || "",
            enableGlobalLogo: true,
          };
          setLogoInfo(logoInfo);
        } else {
          let logoInfo = {
            appBackgroundImage: "",
            appLogo: "",
            enableGlobalLogo: false,
          };
          setLogoInfo(logoInfo);
        }

        if (response && response.settings) {
          let appInfo = response.settings;
          let appDetails = {
            signupHelpWording: appInfo.signUpHelpWording,
            loginWording: appInfo.loginWording,
            enableFRlogin: appInfo.firstresponderAccess,
            enableAddHelp: appInfo.showAdditionalHelpInfo,
          };
          setAppInfo(appDetails);
        }
      })
      .catch((error) => {
        console.log("responser error", error);
        // dologOut();
      });
  };

  const submitDataForLogin = async () => {
    setLoading(true);
    try {
      let signInWith = loginType === "email" ? userEmail : userPhone;
      const userInfo = await Auth.signIn(signInWith);
      setUserAuthInfo(userInfo);
      const { challengeParam } = userInfo;
      setLoading(false);
      if (challengeParam?.USERNAME !== undefined) {
        setEnableOTP(true);
      } else {
        notification.error({
          placement: "top",
          top: 100,
          message: "Something went wrong.!",
          duration: 3,
        });
      }
    } catch (err) {
      let msg =
        err.code === "UserNotConfirmedException"
          ? "Registered user not confirmed.!"
          : err.code === "NotAuthorizedException"
          ? "Incorrect Username"
          : err.code === "UserNotFoundException"
          ? "User not found.!"
          : "Something went wrong.!";
      notification.error({
        placement: "top",
        top: 100,
        message: msg,
        duration: 3,
      });
      setLoading(false);
      console.log(err);
    }
  };

  const submitOTP = () => {
    setLoading(true);
    try {
      Auth.sendCustomChallengeAnswer(userAuthInfo, otp)
        .then(async (response) => {
          if (
            response["challengeParam"] &&
            response["challengeParam"]["errorCode"]
          ) {
            notification.error({
              placement: "top",
              top: 100,
              message: "Invalid OTP",
              duration: 3,
            });
            setLoading(false);
          } else {
            let userId = response.signInUserSession.idToken.payload.sub;
            getLoginUserInfo(userId);
          }
        })
        .catch((err) => {
          notification.error({
            placement: "top",
            top: 100,
            message: "Invalid OTP",
            duration: 3,
          });
          setLoading(false);
        });
    } catch (e) {
      notification.error({
        placement: "top",
        top: 100,
        message: "Invalid OTP",
        duration: 3,
      });
    }
  };

  const getLoginUserInfo = async (userId) => {
    setLoading(true);
    await API.get("list", `/general/get/users/${userId}`, {})
      .then((res) => {
        localStorage.setItem("loginUserId", userId);
        localStorage.setItem("loginOrgId", res?.orgId);
        localStorage.setItem("loginGroupOrgId", res?.orgId);
        if (res?.userProfile === "F") {
          if (res?.isGroupLevel === true) {
            localStorage.setItem("isGroupOrgUser", "true");
          } else {
            localStorage.setItem("isGroupOrgUser", "false");
          }
          if (res?.isWebUser === true) {
            setLoading(false);
            window.location.replace("/dashboard");
          } else {
            setEnableAccessCode(true);
            getFRAccessCodes(res?.orgId);
          }
        } else {
          setLoading(false);
          window.location.replace("/dashboard");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("responser error", error);
      });
  };

  const getFRAccessCodes = async (orgId) => {
    setLoading(true);
    await API.get("list", `/noAuth/list/invitationCodes`, {})
      .then((res) => {
        let matchedOrg = res.find((org) => org.id === orgId);
        if (matchedOrg?.accessCodes?.length > 0) {
          setAccessCodes(matchedOrg?.accessCodes);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("responser error", error);
        setLoading(false);
      });
  };

  const doVerification = () => {
    if (enteredAccessCode.length !== 4) {
      alert("Please enter a valid access code");
      return;
    }

    let validateCode = accessCodes?.filter((itemCode) => {
      if (itemCode.code.toString() === enteredAccessCode) {
        return itemCode;
      }
    });

    if (validateCode && validateCode.length > 0) {
      codeMatched(validateCode[0].code.toString());
    } else {
      setEnteredAccessCode(null);
      alert("Invalid Access Code");
    }
  };

  const codeMatched = async (matchedCode) => {
    localStorage.setItem("accessCode", matchedCode);
    setLoading(false);
    window.location.replace("/dashboard");
  };

  const FRAccessCodeView = () => {
    return (
      <div>
        <div style={{ marginBottom: "20px" }}>
          <Row justify={"center"}>
            <OtpInput
              shouldAutoFocus={true}
              value={enteredAccessCode}
              onChange={(e) => {
                setEnteredAccessCode(e);
              }}
              numInputs={4}
              renderSeparator={<span style={{ width: "20px" }}></span>}
              renderInput={(props) => (
                <input
                  autoFocus={true}
                  {...props}
                  className="text-input"
                  style={{
                    width: "40px",
                    textAlign: "center",
                  }}
                />
              )}
            />
          </Row>
        </div>
        <Row>
          <Button
            htmlType="submit"
            onClick={doVerification}
            className="submit-button"
          >
            <span style={{ color: "#FFF" }}>Submit</span>
          </Button>
        </Row>
      </div>
    );
  };

  const OTPView = () => {
    return (
      <div>
        <div style={{ marginTop: "30px", marginBottom: "30px" }}>
          <OtpInput
            shouldAutoFocus={true}
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span style={{ width: "10px" }}></span>}
            renderInput={(props) => (
              <input
                autoFocus={true}
                {...props}
                className="text-input"
                style={{
                  height: "30px !important",
                  width: "20px",
                  textAlign: "center",
                }}
              />
            )}
          />
        </div>
        <Row>
          <Button
            htmlType="submit"
            onClick={submitOTP}
            className="submit-button"
          >
            <span style={{ color: "#FFF" }}>Login</span>
          </Button>
        </Row>
      </div>
    );
  };

  const LoginView = () => {
    return (
      <div>
        {enableTabs === "both" && (
          <div style={{ marginBottom: "10px" }}>
            <Segmented
              block
              size="large"
              options={[
                {
                  label: `Login with phone`,
                  value: "phone",
                },
                {
                  label: `Login with email`,
                  value: "email",
                },
              ]}
              onChange={(value) => {
                setLoginType(value);
              }}
              defaultValue={loginType}
            />
          </div>
        )}

        {loginType === "phone" ? (
          <Input
            autoFocus={true}
            type="text"
            placeholder="Enter phone number"
            value={userPhone}
            onChange={(e) => setUserPhone(e.target.value)}
            required
            className="text-input"
            style={{
              marginBottom: "40px",
            }}
          />
        ) : (
          <Input
            autoFocus={true}
            type="text"
            placeholder="Enter email"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            required
            className="text-input"
            style={{
              marginBottom: "40px",
            }}
          />
        )}

        <Row>
          <Button
            htmlType="submit"
            onClick={submitDataForLogin}
            className="submit-button"
          >
            <span style={{ color: "#FFF" }}>Send</span>
          </Button>
        </Row>
      </div>
    );
  };

  return (
    <Col
      span={24}
      className="background-login"
      style={{
        maxHeight: `${document.documentElement.clientHeight - 18}px`,
        overflow: "hidden",
      }}
    >
      <Row>
        <Col span={12} className="login-page">
          <div className="login-card show-on-moblie">
            <Row justify={"center"} style={{ marginTop: "45%" }}>
              <Card className="login-container">
                <Row justify={"center"}>
                  <img
                    src={
                      logoInfo?.appLogo !== undefined &&
                      logoInfo?.appLogo !== null &&
                      logoInfo?.appLogo !== ""
                        ? logoInfo?.appLogo
                        : logo
                    }
                    style={{
                      minWidth: "140px",
                      maxWidth: "140px",
                      marginBottom: "20px",
                    }}
                    alt="logo"
                  />
                </Row>

                <Row justify={"center"}>
                  <h3
                    style={{
                      textAlign: "center",
                      fontSize: "25px",
                      marginTop: "-10px",
                      marginBottom: "-10px",
                    }}
                  >
                    {enableAccessCode
                      ? "Enter Valid Access Code"
                      : enableOTP
                      ? "Enter 6 Digit OTP"
                      : "Login"}
                  </h3>
                  {enableAccessCode ? (
                    <p style={{ textAlign: "center", fontSize: "18px" }}></p>
                  ) : enableOTP ? (
                    <p style={{ textAlign: "center", fontSize: "18px" }}></p>
                  ) : (
                    <p style={{ textAlign: "center", fontSize: "18px" }}>
                      {appInfo?.loginWording !== "" &&
                      appInfo?.loginWording !== undefined &&
                      appInfo?.loginWording !== null
                        ? appInfo?.loginWording
                        : "Login or create new account to manage portfolio for yourself or a special person you are caring for"}
                    </p>
                  )}
                </Row>

                <Form>
                  {enableAccessCode
                    ? FRAccessCodeView()
                    : enableOTP
                    ? OTPView()
                    : LoginView()}
                </Form>
              </Card>
            </Row>
            <Row justify={"center"}>
              <h4 style={{ textAlign: "center", color: "#a5a5a5" }}>
                Version 23.9
              </h4>
            </Row>
          </div>
        </Col>
        <Col span={12}>
          <div
            style={{
              "--dynamic-image-url": `url(${
                logoInfo?.appBackgroundImage !== undefined &&
                logoInfo?.appBackgroundImage !== null &&
                logoInfo?.appBackgroundImage !== ""
                  ? logoInfo?.appBackgroundImage
                  : bgUrl
              })`,
            }}
            className="background-img show-on-desktop"
          ></div>
        </Col>
      </Row>
      <Loading enableLoading={loading} />
    </Col>
  );
}

export default Login;
